import { render, staticRenderFns } from "./NoroesteOverview.vue?vue&type=template&id=51aecb7d"
import script from "./NoroesteOverview.vue?vue&type=script&lang=js"
export * from "./NoroesteOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports